import storeModule from '../store-module'
import { defineStore } from 'pinia'

const url = 'settings/banking-correspondents'

export default defineStore(
  'banking-correspondents',
  storeModule.createStoreModule('banking-correspondents', {
    fetchSingleURL: ({ id }) => {
      return id ? `${url}/${id}/edit` : `${url}/new`
    },
    fetchListURL: url,
    replaceURL: ({ id }) => `${url}/${id}`,
    createURL: url
  })
)
